import React from 'react';

import i18n from '../../utilities/i18n';
import { LoadingSpinner, Text, VStack } from '@adc/parallax-component-library';
import { useQuery } from '@tanstack/react-query';
import { systemAboutQueryOptions } from '../../queryOptions';

export default function About() {
  const about = useQuery(systemAboutQueryOptions());

  return (
    <VStack alignSelf="center" margin="auto">
      <Text>{i18n.t('System.About.title')}</Text>

      {about.isPending ? <LoadingSpinner /> : null}

      {about.isError ? <Text>{i18n.t('Common.noData')}</Text> : null}

      {about.isSuccess
        ? Object.entries(about.data).map(([key, value]) => (
            <Text key={key}>{`${key}: ${String(value)}`}</Text>
          ))
        : null}
    </VStack>
  );
}
